import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AdminActionButton } from '../admin-action-button';
import { AdminPanel } from '../admin-panel';
import { AdminPanelBackButton } from '../admin-panel-back-button';
import { AdminPanelBody } from '../admin-panel-body';
import { AdminPanelHeader } from '../admin-panel-header';
import { AdminPanelHeading } from '../admin-panel-heading';
import { AdminPanelHeadingAction } from '../admin-panel-heading-action';
import { AdminPanelHeadingText } from '../admin-panel-heading-text';
import { AdminPanelName } from '../../../state/admin-panels';
import { AdminPlaceListPanelProps } from './admin-place-list-panel-props';
import { AdminPlacesTable } from '../admin-places-table';
import { getWipPage } from '../../../selectors/page';
import { loadPlace } from '../../../actions';
import { replaceAdminPanel } from '../../../actions';
import { uuid } from '@robotsnacks/uuid';

export const AdminPlaceListPanel: React.FunctionComponent<
  AdminPlaceListPanelProps
> = (): React.ReactElement => {
  const dispatch = useDispatch();

  const wipPage = useSelector(getWipPage);

  const onNewPlaceClick = useCallback(() => {
    const placeKey = uuid();
    dispatch(
      loadPlace(
        placeKey,
        wipPage ? { pageId: wipPage.id, pageTitle: wipPage.title } : {},
      ),
    );
    dispatch(replaceAdminPanel(AdminPanelName.Place, { placeKey }));
  }, []);

  return (
    <AdminPanel>
      <AdminPanelHeader>
        <AdminPanelBackButton />
        <AdminPanelHeading>
          <AdminPanelHeadingText>Places</AdminPanelHeadingText>
          <AdminPanelHeadingAction>
            <AdminActionButton
              label="Create New Place"
              onClick={onNewPlaceClick}
            />
          </AdminPanelHeadingAction>
        </AdminPanelHeading>
      </AdminPanelHeader>
      <AdminPanelBody padding="narrow">
        <AdminPlacesTable />
      </AdminPanelBody>
    </AdminPanel>
  );
};
